import AppBar from "@components/AppBar";
import LegalConditionsDialog from "@components/LegalConditions/LegalConditionsDialog";
import { ARA_LOGIN_URL } from "@config";
import LayoutDefault from "@layouts/LayoutDefault";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { pillButtonContained } from "@theme/styles";
import React from "react";
import { useTranslation } from "react-i18next";

const LOCAL_STORAGE_KEY = "legal_conditions_accepted_v1";

const LoginPrompt = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [legalOpen, setLegalOpen] = React.useState(false);

  React.useEffect(() => {
    const hasAccepted = window.localStorage.getItem(LOCAL_STORAGE_KEY) === "1";
    if (!hasAccepted) {
      setLegalOpen(true);
    }
  }, []);

  const handleLoginRedirect = () => {
    window.location.href = `${ARA_LOGIN_URL}${window.location.href}`;
  };

  const handleAcceptLegal = () => {
    window.localStorage.setItem(LOCAL_STORAGE_KEY, "1");
    setLegalOpen(false);
  };

  return (
    <LayoutDefault title="Login">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          backgroundColor: (theme) => theme.palette.background.paper,
          overflow: "hidden"
        }}
      >
        <AppBar />

        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 3,
            p: 3,
            textAlign: "center"
          }}
        >
          <Typography
            variant="h4"
            component="h3"
            sx={{
              fontSize: 25,
              fontWeight: 600,
              textAlign: "center",
              color: (theme) => theme.palette.customColors.textPrimary,
              mb: 0
            }}
          >
            {t("welcome.start_chatting")}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: (theme) => theme.palette.customColors.textSecondary,
              maxWidth: 460
            }}
          >
            {t("welcome.filter_message")}
          </Typography>
          <Button
            variant="contained"
            disableElevation
            onClick={handleLoginRedirect}
            sx={{
              ...pillButtonContained(
                theme.palette.customColors.textPrimary,
                theme.palette.customColors.textSecondary
              ),
              px: 4
            }}
          >
            {t("login.loginButton")}
          </Button>
        </Box>
      </Box>

      <LegalConditionsDialog
        open={legalOpen}
        onAccept={handleAcceptLegal}
        onClose={() => setLegalOpen(false)}
      />
    </LayoutDefault>
  );
};

export default LoginPrompt;
